import React from "react";

import "leaflet/dist/leaflet.css";

import Menu3 from "./components/Menu3.js";

import withRouter from "./withRouter";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import config from "./config.js";

import { StoreContext } from "./store/RootStore";
import { observer } from "mobx-react";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";
import drive7Icon from "../src/assets/images/drive7.ico";
import { loadGoogleMaps } from "./components/googleLoader";
import { decode as base64_decode } from "base-64";


class App extends React.Component {
  constructor(props, context) {
    super(props);

    this.state = { collapsed: false, marginLeft: 80, settingColor: "white" };

    let isMarine = JSON.parse(base64_decode(Cookies.get("data"))).industry;


    let selectedLang = JSON.parse(JSON.stringify(Cookies.get()));
    if (isMarine === "Marine") {
      context.setLocale("marine");
    } else if (selectedLang.language) {
      context.setLocale(selectedLang.language);
    } else {
      context.setLocale("english");
    }
  }
  handlePopState = () => {
    // For example, navigate to the login page
    this.props.navigate("/login");
  };
  async componentDidMount() {
    loadGoogleMaps(config.googleMapKey)
      .then(() => {
        this.setState({ googleLoaded: true });
      })
      .catch(console.error);


    window.addEventListener("popstate", this.handlePopState);
  }

  updateTitle = () => {
    return config.tabTitle ? config.tabTitle : "Trackeazy"
  }

  updateIcons = () => {
    const favicon = config.project
      ? `/logos/${config.project}-favicon.ico`
      : "/logos/trackeazy-favicon.ico";
    return {
      favicon: favicon,
      // favicon: `/logos/${config.project}-favicon.ico`,
      appleTouchIcon: drive7Icon,
    };
  }

  render() {
    const { favicon, appleTouchIcon } = this.updateIcons();


    if (!this.state.googleLoaded) {
      return;
    }

    return (
      <>
        <Helmet>
          <title>{this.updateTitle()}</title>
          <link rel="icon" href={favicon} />
          <link rel="apple-touch-icon" href={appleTouchIcon} />
        </Helmet>
        <div className={config.project === "drive7" ? "drive7-wrapper" : ""}>
          {/* <Menu1 /> */}
          <Menu3 />
        </div>
      </>
    );
  }
}

// export default withRouter(App);
App.contextType = StoreContext;
export default observer(withRouter(App));
